import { gql, graphql } from "@outschool/ui-apollo";

import ClassScheduleRequestFragment from "./ClassScheduleRequestFragment";

export const lastClassScheduleRequestQuery = gql`
  query LastClassScheduleRequest {
    currentUser {
      uid
      lastClassScheduleRequest {
        ...ClassScheduleRequestFragment
      }
    }
  }
  ${ClassScheduleRequestFragment}
`;

export const lastClassScheduleRequestDecorator = graphql(
  lastClassScheduleRequestQuery,
  {
    props({ data }) {
      return {
        loading: data.loading,
        lastClassScheduleRequest:
          data.currentUser && data.currentUser.lastClassScheduleRequest,
      };
    },
  },
);
